export class Tuple3<T1, T2, T3> {
  public item1: T1;
  public item2: T2;
  public item3: T3;

  constructor(item1: T1, item2: T2, item3: T3) {
    this.item1 = item1;
    this.item2 = item2;
    this.item3 = item3;
  }
}
